import { render, staticRenderFns } from "./Required.vue?vue&type=template&id=793a53d4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793a53d4')) {
      api.createRecord('793a53d4', component.options)
    } else {
      api.reload('793a53d4', component.options)
    }
    module.hot.accept("./Required.vue?vue&type=template&id=793a53d4", function () {
      api.rerender('793a53d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/template/Required.vue"
export default component.exports